import styled from 'academy-common-lib/utils/Styling';
import { useLearningContentType } from '../learningContentQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const getWidthForContent = contentType => {
  switch (contentType) {
    case 'VIDEO':
      return 1180;
    default:
      return '850';
  }
};
const Container = styled.div.withConfig({
  displayName: "LearningContentContainer__Container",
  componentId: "sc-19rd3wq-0"
})(["max-width:", "px;margin:0 auto;"], ({
  $contentType
}) => getWidthForContent($contentType));
export const LearningContentContainer = ({
  lessonId,
  trackId,
  language,
  contentId,
  children
}) => {
  const type = useLearningContentType({
    lessonId,
    trackId,
    language,
    contentId
  });
  return /*#__PURE__*/_jsx(Container, {
    $contentType: type,
    children: children
  });
};